import { Injectable } from '@angular/core';
import { Store } from '../../core/services/store.service';

@Injectable({
  providedIn: 'root',
})
export class ContentDataStoreService extends Store<INotificationsCountInfo> {
  public hidden = false;

  constructor() {

    super(null, 'NotificationsCountInfo');
  }

  public refreshDefermentsState(overdueDeferments: number) {
    let { state } = this;
    state.overdueDeferments = overdueDeferments;
    this.setState(state);
  }

}

export interface INotificationsCountInfo {
  urgentLiabilitiesCount: number;
  notSeenOffersCount: number;
  customerBillerNotificationsCount: number;
  overdueDeferments?: number;
}
